function getBaseUrl() {
    const idx = document.location.pathname.indexOf("/", 1);
    return document.location.protocol + "/*                                                                        */
}

const baseUrl = getBaseUrl();

export { baseUrl };
